import DemoVideo from '../shared/DemoVideo';

/**
 * Entra depois do PVScreens e antes do PVCloudFlow: as telas estáticas
 * apresentam a interface, o vídeo mostra ela funcionando, e só então o
 * CloudFlow generaliza para as três superfícies (nuvem, web, app).
 */
export default function PVDemo() {
  return (
    <DemoVideo
      i18nKey="pv.demo"
      base="/assets/pixviewer-demo-v1"
      poster="/assets/pixviewer-demo-poster-v1.jpg"
      background="var(--p2a-dark-panel)"
    />
  );
}
